module.exports = __webpack_public_path__ + "img/workout-notebook_B095R7HFNZ.dca367ea.jpg";